import { $http } from '@/utils';

/**
 * @namespace Service
 * @class UserAddress
 * @exports Service/Account/UserAddress
 * @description API User Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class UserAddress {
	/**
	 * @static @name patch
	 * @description Update some User address for ID
	 * @param {String} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static patch(id, payload) {
		return $http.patch(`account/user/address/${id}`, payload);
	}
}
